import { render, staticRenderFns } from "./FilterBarGenres.vue?vue&type=template&id=7827f189&scoped=true"
import script from "./FilterBarGenres.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBarGenres.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterBarGenres.vue?vue&type=style&index=0&id=7827f189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827f189",
  null
  
)

export default component.exports